import { useMutation } from 'react-query';

import client from '@/apis/aniftyBackend/client';
import { queryClient } from '@/utils/react-query';

import { CreateMintBidParam } from './interface';
export const createMintBid = async (
  data: CreateMintBidParam
): Promise<void> => {
  await client.post<void>(`api/marketplaceV2/primary_bid`, data);
};

export const useCreateMintBid = () => {
  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(['mintBids']);
    },
    mutationFn: createMintBid,
  });
};
